/**
 * Frequency types.
 */
export enum Frequency {
  'Monthly' = 1,
  'Weekly' = 2,
  'BiWeekly' = 3,
}
